import { render, staticRenderFns } from "./addBasePrivilege.vue?vue&type=template&id=5e306c8c"
import script from "./addBasePrivilege.vue?vue&type=script&lang=js"
export * from "./addBasePrivilege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports